import React, { useRef } from 'react';
import { ClipLoader } from 'react-spinners';

interface IProps {
  className: string;
  title: string;
  link: string;
}
const IFrame = ({ className, link, title }: IProps) => {
  return (
    <>
      <iframe className={className} title={title} src={link}></iframe>
      <div className='w-full h-full flex justify-center mt-[100px] absolute top-[20px] z-10'>
        <ClipLoader color={'#F8B400'} size={50} loading={true} />
      </div>
    </>
  );
};

export default IFrame;
